<template>
  <div class="1c">
    <h3 class="uk-margin-medium-top">1C. CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES</h3>
    <p class='uk-text-left'> <b>Analiza la informaciónd basándose en el buró de crédito para contestar las siguientes preguntas:</b> </p>
    <form id="form" class="uk-text-left">
      
      <div class="uk-margin">
        <label >¿Cuál esla última calificación emitida?</label>
        <select class="uk-select" required v-model="data['a - Calificaciones Buró de crédito']" >
          <option value="2">MOP-00 ó simplemente 0 = Cuenta muy reciente para ser calificada</option>
          <option value="7">MOP-01 ó simplemente 1 = Cuenta con pago puntual adecuado</option>
          <option value="6">MOP-02 ó simplemente 2 = Cuenta con atraso de 1 a 29 días</option>
          <option value="5">MOP-03 ó simplemente 3 = Cuenta con atraso de 30 a 59 días</option>
          <option value="4">MOP-04 ó simplemente 4 = Cuenta con atraso de 60 a 89 días</option>
          <option value="3">MOP-05 ó simplemente 5 = Cuenta con atraso de 90 a 119 días</option>
          <option value="2">MOP-06 ó simplemente 6 = Cuenta con atraso de 120 a 149 días</option>
          <option value="1">MOP-07 ó simplemente 7 = Cuenta con atraso de 150 a 365 días</option>
          <option value="0">MOP-96 ó simplemente 96 = Cuenta con atraso de más de 12 meses</option>
        </select>
      </div>

      <hr>
      
        <p> <b>Gastos financieros</b> <br> </p>

        <div class="uk-child-width-1-2 " uk-grid> 
          <div>
            <label>a) Deudas en la propia institución</label>
          </div>
          <div>
            <input type="text" v-model="data['Propia Institución Observaciones']" class="uk-input " placeholder="Observaciones" >
          </div>
          <div>
            <input type="number" v-model="data['Propia Institución Saldo']" class="uk-input " placeholder="$ -Sume la totalidad de deuda total" step="0.01" >
          </div>
          <div>
            <input type="number" v-model="data['Propia Institución Pago']" class="uk-input " placeholder="$ -Sume la totalidad de pago al mes" step="0.01" >
          </div>
        </div>

        <hr>

        <div class="uk-child-width-1-2 " uk-grid> 
          <div>
            <label>b) Deudas en el resto del sistema financiero formal</label>
          </div>
          <div>
            <input type="text" v-model="data['Sistema Financiero Observaciones']" class="uk-input " placeholder="Observaciones" >
          </div>
          <div>
            <input type="number" v-model="data['Sistema Financiero Saldo']" class="uk-input " placeholder="$ -Sume la totalidad de deuda total" step="0.01" >
          </div>
          <div>
            <input type="number" v-model="data['Sistema Financiero Pago']" class="uk-input " placeholder="$ -Sume la totalidad de pago al mes" step="0.01" >
          </div>
        </div>

        

        <hr>

        <p>Total de gastos financieros reportados: <br>Saldo actual total: <b>{{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(deuda)}}</b>  <br>Monto total a pagar al mes: <b>{{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(pago)}}</b> </p>


      <div class="uk-margin uk-text-center">
        <button class="uk-button uk-button-primary">siguiente</button>
      </div>


    </form>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      data : this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES'] ? this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES'] : {},
    }
  },
  computed:{
    calif : function(){
      var value = this.data['a - Calificaciones Buró de crédito'] * 10
      this.data['PUNTAJE TOTAL'] = value
      return value
    },
    deuda:function(){
      var ing = 0.0

        if(this.data['Propia Institución Saldo']) ing += parseFloat(this.data['Propia Institución Saldo'])
        if(this.data['Sistema Financiero Saldo']) ing += parseFloat(this.data['Sistema Financiero Saldo'])


      if(isNaN(ing)){
        return 0
      }

      this.data['Deuda Total'] = ing.toFixed(2)
      
      return ing.toFixed(2)
    },
    pago:function(){
      var ing = 0.0

        if(this.data['Propia Institución Pago']) ing += parseFloat(this.data['Propia Institución Pago'])
        if(this.data['Sistema Financiero Pago']) ing += parseFloat(this.data['Sistema Financiero Pago'])
        
      if(isNaN(ing)){
        return 0
      }

      this.data['Pago Mensual Total'] = ing.toFixed(2)

      return ing.toFixed(2)
    },
  },
  mounted: function(){
    document.getElementById('form').addEventListener('submit',function(e){
      e.preventDefault()
      var cal = this.calif + 1
      
      this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES'] = this.data
      sessionStorage.setItem('score',JSON.stringify(this.$score))
      if(sessionStorage.getItem('loaded')){
        this.$router.push('6c')
      } else {
        this.$router.push('2c')
      }
    }.bind(this))
    window.scroll(0,0)
    if(sessionStorage.getItem('score')){
      this.$score = JSON.parse(sessionStorage.getItem('score'))
      if(this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES']){
        this.data = this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES']
        this.data['Otras Instituciones Saldo'] = this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES']['Deuda']
        var d = this.deuda
        this.data['Deuda'] = d
      }
    } 
  }
    
}
</script>
